module.exports = __webpack_public_path__ + "static/media/Sharvari_Phand.dafd3335.jpg";